
export const environment = {
    production: false,
    apiUrl: 'https://api-dev.broker.crownly.co/broker/v1',
    ratingApiUrl: 'https://api-dev.broker.crownly.co/rating/v1',
    clientId: 'aa7c4054-a1bb-42fb-a938-d0a02e388473',
    client_secret: '550e8400-e29b-41d4-a716-446655440000'
}
